import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LeaveUsPhoneComponent } from './leave-us-phone/leave-us-phone.component';

const routes: Routes = [
  {path: '', component: HomeComponent},

  {path: 'leave-us-phone', component: LeaveUsPhoneComponent},
  {path: 'leave-us-phone/', component: LeaveUsPhoneComponent},

  {path: '**', component: HomeComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
